import { cn } from "@/lib/utils";

type EyebrowProps = {
  label: string;
  code?: string;
  dark?: boolean;
  className?: string;
};

const Eyebrow = ({ label, code, dark, className }: EyebrowProps) => (
  <div className={cn("flex items-center justify-between gap-4", className)}>
    <p className={cn("label-sm !mb-0 flex items-center gap-3", dark && "!text-primary/70")}>
      <span className={cn("h-px w-8", dark ? "bg-primary/45" : "bg-primary/40")} aria-hidden="true" />
      <span>{label}</span>
    </p>
    {code ? (
      <span
        className={cn(
          "border-l pl-4 font-mono text-[10px] tracking-[0.16em] uppercase",
          dark ? "border-[hsl(var(--sd-fg)/0.12)] text-[hsl(var(--sd-fg)/0.36)]" : "border-border/60 text-foreground/36",
        )}
      >
        {code}
      </span>
    ) : null}
  </div>
);

export default Eyebrow;
